import React from "react";
import propTypes from 'prop-types'
import { Checkbox, Dropdown, Flowbite } from "flowbite-react";
import { dropDownWithBorder } from "../../../theme/flowbite.custom.theme";

export const MultiSelectWithBordersComponent = React.memo(({ options, handleChange, loader, numberofItemsShown, placeholderText, customComponent,theme }) => {
 
    const getLabel = () => {
        const selected = options?.length && options?.filter(option => option?.checked)?.map(option => option?.name);
        return <>
            <span className={`truncate ${numberofItemsShown < 2 ? 'max-w-200' : 'max-w-lg'}  ${selected?.length ? 'text-secondary-500' : ''}`}>
                {loader ? "Loading..." : (selected?.length && selected?.join(', ')) || placeholderText}</span>
            {(selected?.length) >= 3 && <span className="bg-primary-50 text-secondary-500 p-1">{`+${(selected?.length) > 0 ? selected?.length - 2 : ""} `} </span>}
        </>
    }

    return (<div className="flex gap-2 items-center">
        <Flowbite theme={{ theme: theme }}>
            <Dropdown
                inline
                label={getLabel()}
                disabled={loader}
                dismissOnClick={false}
                isOpen={true}
                className="border border-secondary-200 ">
                {!!options?.length
                    && options?.map((option, subIndex) => <Dropdown.Item className="block mr-0 text-start gap-4 truncate" key={option?.name} role="button" onClick={() => handleChange(option, subIndex)}>
                        <Checkbox value={option?.checked} readOnly checked={option?.checked} />   <span className="mx-2 leading-15">{option?.name}</span>
                    </Dropdown.Item>)}
            </Dropdown>
        </Flowbite>
        {customComponent && <div>{customComponent}</div>}
    </div>
    );
});

MultiSelectWithBordersComponent.propTypes = {
    options: propTypes.array,
    handleChange: propTypes.func,
    loader: propTypes.bool,
    numberofItemsShown: propTypes.number,
    placeholderText: propTypes.string,
    theme:propTypes.object
}

MultiSelectWithBordersComponent.defaultProps = {
    options: [],
    handleChange: () => null,
    loader: false,
    numberofItemsShown: 2,
    placeholderText: "Click to  Select",
    theme:dropDownWithBorder
}
